module.exports = __webpack_public_path__ + "assets/img/28_1063.460e835f.jpg";